<template>

  <!-- 1st Hero Variation -->
  <section class="section section-shaped section-lg my-0" style="background-color: black;">

    <div class="container alert alert-warning" >
      <div class="row">

        <div class=" col-lg-12">
          <div class="col-lg-12">
            <select class="form-control" @change="changeFunnelFilter" v-model="current_funnel">
              <option :value="null">Выберите воронку</option>
              <option v-if="funnels.length>0" v-for="funnel in funnels" :value="funnel.last_id"
                      :key="funnel.last_id">{{
                  funnel.title
                }}
              </option>
            </select>
          </div>


        </div>

      </div>
    </div>
  </section>

</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Api from "../models/Api";
import Modal from "@/components/Modal";
import CircleChart from "@/models/CircleChart";
import vueKanban from 'vue-kanban'


export default {
  name: "home",

  data() {

    var app = this;

    return {

      stages: [],
      current_funnel:null,
      blocks: [

      ],
      "funnels": {},


    }
  },

  mounted: function () {

    var app = this;
    Api.loadFunnels(function (data) {

      if(data.funnels.length>0){
        app.funnels=data.funnels;
      }



    })






  },
  methods: {
    callModalAddLead() {
      var app=this;
      var params = {

        type: "addlead",
        islead: true,
        funnel_id:app.current_funnel,

        modal_title: "Добавление лида",

        json: {
          "blocks": [{
            "type": "header",
            "data": {
              "text": "Безымянный проект",
              "level": 2
            }
          }]
        }
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    },
    changeFunnelFilter(){
    var app=this;
      app.$router.push({name: 'funnel', params: {id: app.current_funnel, "rand": Math.random()}});
    }

  },
  components: {Modal}
};
</script>